import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { actions as ppcActions } from '../../reducers/ppc.reducer';
import useAppGroup from '../../helpers/hooks/useAppGroup';
import PpcServiceCategories from './PpcServiceCategories.react';
import PpcServices from './PpcServices.react';
var Services = function Services() {
  var dispatch = useDispatch();
  var _useParams = useParams(),
    app = _useParams.app;
  var appGroup = useAppGroup({
    app: app
  });
  useEffect(function () {
    dispatch({
      type: ppcActions.serviceCategory,
      payload: {
        formData: {
          app: app
        }
      }
    });
    dispatch({
      type: ppcActions.service,
      payload: {
        route: 'index',
        formData: {
          app: app
        }
      }
    });
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, appGroup === 'ppc' && /*#__PURE__*/React.createElement(React.Fragment, null, app === 'ppark' && /*#__PURE__*/React.createElement(PpcServiceCategories, null), /*#__PURE__*/React.createElement(PpcServices, null))));
};
export default Services;